import * as React from 'react';
import { DSFormControl, DSSelect, DSInputLabel, DSMenuItem, Translate } from '@deltasierra/components';
import { useAngularServiceContext } from '../../componentUtils/angularServiceContexts';

export type LocaleSelectProps = {
    initialLocale: string;
    onChange?: (localeCode: string) => void;
};

export function LocaleSelect({ initialLocale, onChange }: LocaleSelectProps): JSX.Element {
    const i18nService = useAngularServiceContext('I18nService');
    const [currentLocale, setCurrentLocale] = React.useState(initialLocale);

    const localeList = React.useMemo(() => i18nService.getLocales(), [i18nService]);

    return (
        <DSFormControl fullWidth>
            <DSInputLabel id="locale-select-label" shrink>
                <Translate keyId="COMMON.LOCALE" />
            </DSInputLabel>
            <DSSelect
                id="locale-select"
                labelId="locale-select-label"
                value={currentLocale}
                onChange={event => {
                    setCurrentLocale(event.target.value as string);
                    onChange?.(event.target.value as string);
                }}
            >
                {localeList.map(locale => (
                    <DSMenuItem key={locale.code} value={locale.code}>
                        {locale.title}
                    </DSMenuItem>
                ))}
            </DSSelect>
        </DSFormControl>
    );
}

LocaleSelect.displayName = 'LocaleSelect';
